<script>
import algoliasearch from 'algoliasearch/lite';
import VueSlider from 'vue-slider-component';
const functions = require('firebase-functions');
import { AisSortBy } from 'vue-instantsearch';
import cx from 'classnames';
import ClearRefinements from '../widgets/ClearRefinements.vue';
import NoResults from '../widgets/NoResults.vue';
import { formatNumber } from '../utils';
import { AisRefinementList } from 'vue-instantsearch';
import getRouting from '../routing';
import firebase from 'firebase/compat/app';

import '../widgets/Theme.css';
import '../widgets/App.css';
import '../widgets/App.mobile.css';
import '../widgets/PriceSlider.css';

// const APP_ID = functions.config().algolia.app;
// const ADMIN_KEY = functions.config().algolia.key;

// const client = algoliasearch(APP_ID, ADMIN_KEY);

export default {
  components: {
    AisRefinementList,
    VueSlider,
    ClearRefinements,
    NoResults,
    AisSortBy,
  },
  created() {
    this.onKeyUp = (event) => {
      if (event.key !== 'Escape') {
        return;
      }
      this.closeFilters();
    };

    this.onClick = (event) => {
      if (event.target !== this.header) {
        return;
      }

      this.closeFilters();
    };
  },
  mounted() {
    this.resultsContainer = document.querySelector('.container-results');
    this.header = document.querySelector('#header');
  },
  data() {
    return {
      cx,
      searchClient: algoliasearch(
        '1JDWEV758P',
        '0346044b03e8fbd88b03315596e5184c'
      ),
      routing: getRouting({ indexName: 'Strapp' }),
    };
  },
  methods: {
    toInbox: async function (item) {
      let uid = item.userID;

      await firebase
        .firestore()
        .collection('users')
        .doc(uid)
        .get()
        .then((querySnapshot) => {
          // this.avatar =  querySnapshot.data().avatar

          console.log(querySnapshot.data());
          this.avatarPic = querySnapshot.data().avatar;
        });

      console.log('to inbox');
      localStorage.setItem('chatUser', JSON.stringify(item));
      localStorage.setItem('chatUserAvatar', this.avatarPic);
      // if (!this.userIsAuthenticated) {
      //   this.loginDialog = true;
      //   this.continueMessageLenderAfterLogin = true;
      // }
      // else {
      this.$router.push('/inbox');
      // }
    },
    transformItems(items) {
      console.log(items);
      // return items.map(item => ({
      //   ...item,
      //   itemName: item.itemName.toUpperCase(),
      // }));
    },
    //     createKey(){
    //       const publicKey = client.generateSecuredApiKey(
    //   '6fbff925cf71b3753dc31ec929017145',
    //   {
    //     filters: 'status:available'
    //   }
    // );

    // console.log('public filter key:', publicKey);
    //     },
    formatNumber,
    toValue(value, range) {
      console.log('value', value);
      return [
        typeof value.min === 'number' ? value.min : range.min,
        typeof value.max === 'number' ? value.max : range.max,
      ];
    },
    getSelectedHitsPerPageValue() {
      const [, hitsPerPage] =
        document.location.search.match(/hitsPerPage=([0-9]+)/) || [];
      return Number(hitsPerPage);
    },
    openFilters() {
      document.body.classList.add('filtering');
      window.scrollTo(0, 0);
      window.addEventListener('keyup', this.onKeyUp);
      window.addEventListener('click', this.onClick);
    },
    closeFilters() {
      document.body.classList.remove('filtering');
      this.resultsContainer.scrollIntoView();
      window.removeEventListener('keyup', this.onKeyUp);
      window.removeEventListener('click', this.onClick);
    },
  },
  computed: {
    newItems() {
      return this.$store.getters.featuredItems;
    },
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '150px';
        case 'sm':
          return '200px';
        case 'md':
          return '200px';
        case 'lg':
          return '250px';
        case 'xl':
          return '250px';
      }
    },
    imageWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '150px';
        case 'sm':
          return '150px';
        case 'md':
          return '200px';
        case 'lg':
          return '280px';
        case 'xl':
          return '280px';
      }
    },
  },
};
</script>

<template>
  <div id="root">
    <ais-instant-search
      :search-client="searchClient"
      index-name="strapp_requests"
    >
      <ais-configure
        :attributesToSnippet="['description:10']"
        snippetEllipsisText="…"
        removeWordsIfNoResults="allOptional"
      />

      <header
        class="header hidden-sm-and-down mt-12"
        style="min-height: 128px; padding: 0.5rem 1rem; text-align: center"
        id="header"
      >
        <!-- <v-img src="../../public/images/cover.jpg" class="grid"> -->
        <ais-search-box placeholder="Laptops, exercise bikes, cameras…">
          <template v-slot:submit-icon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 18"
              width="16"
              height="16"
            >
              <g
                fill="none"
                fill-rule="evenodd"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.67"
                transform="translate(1 1)"
              >
                <circle cx="7.11" cy="7.11" r="7.11"></circle>
                <path d="M16 16l-3.87-3.87"></path>
              </g>
            </svg>
          </template>
        </ais-search-box>
        <!-- </v-img> -->
      </header>

      <header
        class="header mt-n16 mb-15 overwrite hidden-md-and-up"
        id="header"
      >
        <ais-search-box placeholder="Laptops, exercise bikes, cameras…">
          <template v-slot:submit-icon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 18 18"
              width="16"
              height="16"
            >
              <g
                fill="none"
                fill-rule="evenodd"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.67"
                transform="translate(1 1)"
              >
                <circle cx="7.11" cy="7.11" r="7.11"></circle>
                <path d="M16 16l-3.87-3.87"></path>
              </g>
            </svg>
          </template>
        </ais-search-box>
      </header>

      <main
        style="display: flex; justify-content: center"
        class="container mt-n8"
      >
        <div class="container-wrapper">
          <!-- <section class="container-filters">
            <div class="container-header">
              <h2 style="color: #7b1fa2">Categories</h2>
            </div>

            <div class="container-body">
              <ais-panel>
                <template v-slot:default>
                  <ais-hierarchical-menu :attributes="['catagory']" />
                </template>
              </ais-panel>
              <ais-clear-refinements data-layout="desktop">
                <template v-slot:resetLabel>
                  <div class="clear-filters">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="10"
                      viewBox="0 0 11 11"
                    >
                      <g fill="none" fill-rule="evenodd" opacity=".4">
                        <path d="M0 0h11v11H0z"></path>
                        <path
                          fill="#000"
                          fill-rule="nonzero"
                          d="M8.26 2.75a3.896 3.896 0 1 0 1.102 3.262l.007-.056a.49.49 0 0 1 .485-.456c.253 0 .451.206.437.457 0 0 .012-.109-.006.061a4.813 4.813 0 1 1-1.348-3.887v-.987a.458.458 0 1 1 .917.002v2.062a.459.459 0 0 1-.459.459H7.334a.458.458 0 1 1-.002-.917h.928z"
                        ></path>
                      </g>
                    </svg>
                    Clear filters
                  </div>
                </template>
              </ais-clear-refinements>
              <ais-panel>
                <template style="color: #7b1fa2; !important" class="secondary--text" v-slot:header>Price</template>

                <template v-slot:default>
                  <ais-range-input attribute="dailyFee">
                    <template
                      v-slot="{ currentRefinement, range, refine, canRefine }"
                    >
                      <vue-slider
                        :min="range.min"
                        :max="range.max"
                        :value="toValue(currentRefinement, range)"
                        :disabled="!canRefine"
                        :lazy="true"
                        :useKeyboard="true"
                        :enableCross="false"
                        tooltip="always"
                        :duration="0"
                        @change="refine({ min: $event[0], max: $event[1] })"
                      >
                        <template v-slot:dot="{ index, value }">
                          <div
                            :aria-valuemin="range.min"
                            :aria-valuemax="range.max"
                            :aria-valuenow="value"
                            :data-handle-key="index"
                            class="vue-slider-dot-handle"
                            role="slider"
                            tabindex="0"
                          />
                        </template>
                        <template v-slot:tooltip="{ value }">
                          {{ formatNumber(value) }}
                        </template>
                      </vue-slider>
                    </template>
                  </ais-range-input>
                </template>
              </ais-panel>
            </div>
          </section> -->

          <footer class="container-filters-footer" data-layout="mobile">
            <clear-refinements
              class="container-filters-footer-button-wrapper"
              @click="closeFilters"
            />

            <ais-stats class="container-filters-footer-button-wrapper">
              <template v-slot="{ nbHits }">
                <button class="button button-primary" @click="closeFilters">
                  See {{ formatNumber(nbHits) }} results
                </button>
              </template>
            </ais-stats>
          </footer>
        </div>
        <!-- <button class="button button-primary" @click="createKey()">
                 create key
                </button> -->
        <section class="container-results">
          <header class="container-header container-options">
            <!-- <ais-sort-by
              class="container-option"
              :items="[
                { value: 'instant_search', label: 'Featured' },
                { value: 'instant_search_createdAt_desc', label: 'Newest First' },

              ]"
               :transform-items="transformItems"
            /> -->

            <ais-hits-per-page
              class="container-option"
              :items="[
                {
                  label: '24 hits per page',
                  value: 24,
                  default:
                    getSelectedHitsPerPageValue() === 24 ||
                    !getSelectedHitsPerPageValue(),
                },
                {
                  label: '48 hits per page',
                  value: 48,
                  default: getSelectedHitsPerPageValue() === 48,
                },
                {
                  label: '96 hits per page',
                  value: 96,
                  default: getSelectedHitsPerPageValue() === 96,
                },
              ]"
            />
          </header>

          <ais-hits>
            <template #default="{ items }">
              <div class="movies">
                <ais-state-results>
                  <template #default="{ results: { query, hits } }">
                    <p class="movies-no-results" v-show="hits.length === 0">
                      No results found matching <strong>{{ query }}</strong
                      >.
                    </p>
                  </template>
                </ais-state-results>

                <div v-if="$vuetify.breakpoint.xsOnly">
                  <article v-for="item in items" :key="item.objectID">
                    <v-row class="grid">
                      <v-col cols="12">
                        <v-card class="pa-4 round grey lighten-3 ma-1">
                          <v-card
                            :height="imageHeight"
                            :width="imageWidth"
                            style="border-radius: 12px"
                          >
                            <v-img
                              v-if="item.images.length > 0"
                              :height="imageHeight"
                              :width="imageWidth"
                              :src="item.images ? item.images[0] : ''"
                            />

                            <v-img
                              v-else
                              :height="imageHeight"
                              :width="imageWidth"
                              :src="require('@/assets/logos/icon1.svg')"
                            />
                          </v-card>
                          <v-row class="d-flex justify-space-between">
                            <v-card-text class="text-h6 ml-n2">
                              {{ item.created_by }} is looking for a
                              {{ item.name }} in {{ item.area }}
                              <!-- <v-spacer></v-spacer>
                                <span class="font-weight-light text-body-2">
                                  12 days ago
                                </span> -->
                            </v-card-text>
                          </v-row>

                          <v-row>
                            <v-card-text class="secondary--text">
                              {{ item.startDateText }} to
                              {{ item.endDateText }}
                            </v-card-text>
                          </v-row>
                          <v-row class="mt-n3">
                            <v-card-text>
                              <span class="font-weight-bold">
                                R{{ item.dailyFee }} per day <br /><br
                              /></span>
                              {{ item.description }}
                            </v-card-text>
                            <v-btn
                              class="appbutton white--text font-weight-medium mt-3 mb-3"
                              color="#b22af0"
                              rounded
                              large
                              elevation="6"
                              @click="toInbox(item)"
                              z-index="12"
                              id="message-lender-search-requests"
                            >
                              Message user<v-icon small class="ml-2"
                                >fas fa-chevron-right</v-icon
                              >
                            </v-btn>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </article>
                </div>

                <div v-if="$vuetify.breakpoint.smAndUp">
                  <article v-for="item in items" :key="item.objectID">
                    <v-row class="grid">
                      <v-col cols="12" md="10">
                        <v-card class="pa-4 round grey lighten-3 ma-1">
                          <v-row>
                            <v-col cols="4" md="4" xl="3" class="grid">
                              <v-card
                                :height="imageHeight"
                                :width="imageWidth"
                                style="border-radius: 12px"
                              >
                                <v-img
                                  v-if="item.images.length > 0"
                                  :height="imageHeight"
                                  :width="imageWidth"
                                  :src="item.images ? item.images[0] : ''"
                                />

                                <v-img
                                  v-else
                                  :height="imageHeight"
                                  :width="imageWidth"
                                  :src="require('@/assets/logos/icon1.svg')"
                                />
                              </v-card>
                            </v-col>
                            <v-col cols="8" md="6" xl="7">
                              <v-row class="d-flex justify-space-between">
                                <v-card-text class="text-h6 ml-n2">
                                  {{ item.created_by }} is looking for a
                                  {{ item.name }} in {{ item.area }}
                                  <!-- <v-spacer></v-spacer>
                                <span class="font-weight-light text-body-2">
                                  12 days ago
                                </span> -->
                                </v-card-text>
                              </v-row>

                              <v-row>
                                <v-card-text class="secondary--text">
                                  {{ item.startDateText }} to
                                  {{ item.endDateText }}
                                </v-card-text>
                              </v-row>
                              <v-row class="mt-n3">
                                <v-card-text>
                                  <span class="font-weight-bold">
                                    R{{ item.dailyFee }} per day <br /><br
                                  /></span>
                                  {{ item.description }}
                                </v-card-text>
                                <v-btn
                                  class="appbutton white--text font-weight-medium mt-3 mb-3"
                                  color="#b22af0"
                                  rounded
                                  large
                                  elevation="6"
                                  @click="toInbox(item)"
                                  z-index="12"
                                  id="message-lender-requests"
                                >
                                  message {{ item.created_by
                                  }}<v-icon small class="ml-2"
                                    >fas fa-chevron-right</v-icon
                                  >
                                </v-btn>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </article>
                </div>
              </div>
            </template>
          </ais-hits>

          <no-results />

          <footer class="container-footer">
            <ais-pagination :padding="2">
              <template
                v-slot="{
                  currentRefinement,
                  pages,
                  isFirstPage,
                  isLastPage,
                  refine,
                  createURL,
                }"
              >
                <ul class="ais-Pagination-list">
                  <li
                    class="ais-Pagination-item ais-Pagination-item--previousPage ais-Pagination-item--disabled"
                    v-if="isFirstPage"
                  >
                    <span class="ais-Pagination-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 10 10"
                        width="10"
                        height="10"
                      >
                        <g
                          fill="none"
                          fill-rule="evenodd"
                          stroke="#000"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.143"
                        >
                          <path d="M9 5H1M5 9L1 5l4-4"></path>
                        </g>
                      </svg>
                    </span>
                  </li>

                  <li
                    class="ais-Pagination-item ais-Pagination-item--previousPage"
                    v-if="!isFirstPage"
                  >
                    <a
                      class="ais-Pagination-link"
                      :href="createURL(currentRefinement - 1)"
                      @click.prevent="refine(currentRefinement - 1)"
                      aria-label="Previous"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 10 10"
                        width="10"
                        height="10"
                      >
                        <g
                          fill="none"
                          fill-rule="evenodd"
                          stroke="#000"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.143"
                        >
                          <path d="M9 5H1M5 9L1 5l4-4"></path>
                        </g>
                      </svg>
                    </a>
                  </li>

                  <li
                    :class="
                      cx('ais-Pagination-item', 'ais-Pagination-item--page', {
                        'ais-Pagination-item--selected':
                          page === currentRefinement,
                      })
                    "
                    v-for="page in pages"
                    :key="page"
                  >
                    <a
                      class="ais-Pagination-link"
                      :href="createURL(page)"
                      :style="{
                        fontWeight: page === currentRefinement ? 'bold' : '',
                      }"
                      @click.prevent="refine(page)"
                      >{{ page + 1 }}</a
                    >
                  </li>

                  <li
                    class="ais-Pagination-item ais-Pagination-item--nextPage"
                    v-if="!isLastPage"
                  >
                    <a
                      class="ais-Pagination-link"
                      :href="createURL(currentRefinement + 1)"
                      @click.prevent="refine(currentRefinement + 1)"
                      aria-label="Next"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 10 10"
                        width="10"
                        height="10"
                      >
                        <g
                          fill="none"
                          fill-rule="evenodd"
                          stroke="#000"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.143"
                        >
                          <path d="M1 5h8M5 9l4-4-4-4"></path>
                        </g>
                      </svg>
                    </a>
                  </li>

                  <li
                    class="ais-Pagination-item ais-Pagination-item--nextPage ais-Pagination-item--disabled"
                    v-if="isLastPage"
                  >
                    <span class="ais-Pagination-link">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 10 10"
                        width="10"
                        height="10"
                      >
                        <g
                          fill="none"
                          fill-rule="evenodd"
                          stroke="#000"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="1.143"
                        >
                          <path d="M1 5h8M5 9l4-4-4-4"></path>
                        </g>
                      </svg>
                    </span>
                  </li>
                </ul>
              </template>
            </ais-pagination>
          </footer>
        </section>
      </main>

      <!-- <aside data-layout="mobile">
        <button class="filters-button" @click="openFilters">
          <svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 16 14">
            <path
              d="M15 1H1l5.6 6.3v4.37L9.4 13V7.3z"
              stroke="#fff"
              stroke-width="1.29"
              fill="none"
              fill-rule="evenodd"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          Categories
        </button>
      </aside> -->
    </ais-instant-search>
  </div>
</template>

<style scoped>
.overwrite {
  align-items: center;
  background-position: center;
  background-size: cover;
  color: #fff;
  display: flex;
  padding-top: -100px !important;
  flex-direction: column;
  justify-content: center;
  min-height: 168px !important;
  text-align: center;
}

.round {
  border-radius: 12px;
}
.item {
  cursor: pointer;
}
.grid {
  display: grid;
  place-items: center;
}
.clip {
  text-overflow: clip;
  white-space: nowrap;
  overflow: hidden;
}

.itmcrd {
  transition: opacity 0s ease-in-out;
}
.itmcrd:hover {
  opacity: 0.8;
}
.google-map {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: #fff;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
}
</style>
